
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spareparts",
      function () {
        return require("private-next-pages/spareparts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spareparts"])
      });
    }
  